// src/components/orders/OrderDetailsUtils/api.js
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASEURL;

/**
 * Fetch order details from the server
 * @param {string} orderId - The order ID
 * @param {string} token - Authentication token
 * @returns {Promise} - Promise that resolves to the order data
 */
export const fetchOrderDetails = async (orderId, token) => {
    return axios.get(`${baseURL}/api/orders/${orderId}`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
};

/**
 * Fetch order status from the server
 * @param {string} orderId - The order ID
 * @param {string} token - Authentication token
 * @returns {Promise} - Promise that resolves to the order status
 */
export const fetchOrderStatus = async (orderId, token) => {
    return axios.get(`${baseURL}/user/customer-portal/${orderId}/getStatus`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
};

/**
 * Fetch invoice data from the server with the current options
 * @param {string} orderId - The order ID
 * @param {string} token - Authentication token
 * @param {Object} options - Order options (hardware, assembly, etc.)
 * @returns {Promise} - Promise that resolves to the invoice data
 */
export const fetchInvoiceData = async (orderId, token, options) => {
    return axios.post(
        `${baseURL}/user/customer-portal/${orderId}`,
        options,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
};

/**
 * Update order options
 * @param {string} orderId - The order ID
 * @param {string} token - Authentication token
 * @param {Object} options - Updated order options
 * @returns {Promise} - Promise that resolves to the updated invoice data
 */
export const updateOrderOptions = async (orderId, token, options) => {
    return axios.post(
        `${baseURL}/user/customer-portal/${orderId}`,
        options,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
};

export const submitFinishingOptions = async (orderId, token, options) => {
    return axios.post(
        `${baseURL}/user/customer-portal/${orderId}/setFinishingOptions`,
        options,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
}